import { IDocument, ITextarea } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

export interface CodeControlWithValue {
  readonly control: ITextarea;
  readonly type: 'code';
  value: string;
}

/**
 * Check that input control meta is code meta
 *
 * @param control - control metadata
 */
export function isCodeControl(control: ITextarea): boolean {
  return control.$editor === 'yes';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 * @param doc - doc
 */
export function getTypeControlForCode(
  control: ITextarea,
  doc: IDocument,
): CodeControlWithValue {
  return {
    value: DocHelper.getStringValue(control.$name, doc),
    control,
    type: 'code',
  };
}
